import styled from "styled-components";

import DiscoverDropdown from "./components/DiscoverDropdown/DiscoverDropdown";
import ReportingMenuLink from "./components/ReportingMenuLink/ReportingMenuLink";
import ShopDropdown from "./components/ShopDropdown/ShopDropdown";
import WorkspacesDropdown from "./components/WorkspacesDropdown/WorkspacesDropdown";
import { HomeIds } from "./navbarRevamp.ids";
import { ReactComponent as JoorLogo } from "../JoorLogo.svg";
import AccountIndicator from "ui/AccountIndicator";
import createAbsolutePath from "createAbsolutePath";
import { ActiveProfileQuery } from "operations";
import AccountDropdown from "./components/AccountDropdown/AccountDropdown";
import SwitchToAccountDropdown from "./components/SwitchToAccountDropdown/SwitchToAccountDropdown";
import ConnectionsDropdown from "./components/ConnectionsDropdown/ConnectionsDropdown";
import ManageProfileMenuLink from "./components/ManageProfileMenuLink/ManageProfileMenuLink";

const NavbarRevampContainer = styled.div`
  * a {
    color: var(--color-secondary-100);
  }

  * a:hover {
    color: var(--color-secondary-100);
  }
`;

const NavbarHeader = styled.div`
  background-color: var(--color-primary-800);
  display: flex;
  position: fixed;
  margin: 0;
  width: 100%;
  top: 0;
  left: 0;
  right: auto;
  bottom: auto;
  z-index: 20000;
  height: 53px;
  font-size: var(--size-font-small);
  font-weight: var(--font-weight-medium);
  font-family: var(--font-family-alpha);
`;

const HomeLink = styled.a`
  border-bottom: none;
  padding: 13px 12px;
  img {
    width: 80px;
    height: auto;
  }
  &:hover {
    background: inherit;
  }
`;

const RightOptionsContainer = styled.div`
  display: flex;
  margin-left: auto;
  margin-right: 12px;
`;

const NavbarRevamp = (props: ActiveProfileQuery) => (
  <NavbarRevampContainer>
    <NavbarHeader data-testid="navbar">
      <AccountIndicator {...props} />
      <HomeLink
        href={createAbsolutePath("/accounts/home")}
        data-testid={HomeIds.HomeLinkTrigger}
      >
        <JoorLogo />
      </HomeLink>
      <ShopDropdown />
      <WorkspacesDropdown />
      <DiscoverDropdown />
      <ConnectionsDropdown />
      <ReportingMenuLink />
      <ManageProfileMenuLink {...props} />
      <RightOptionsContainer>
        <AccountDropdown {...props} />
        <SwitchToAccountDropdown {...props} />
      </RightOptionsContainer>
    </NavbarHeader>
  </NavbarRevampContainer>
);

export default NavbarRevamp;
